import { differenceInMilliseconds } from 'date-fns';
import { TherapyConditionDto, TherapyConditionDtoTherapyCondition } from '../api/generated/model';

export function getTherapyConditionStatusText(conditionStatus: TherapyConditionDtoTherapyCondition) {
  switch (conditionStatus) {
    case TherapyConditionDtoTherapyCondition.BARELY_NOTICEABLE:
      return 'Kaum bemerkbar';
    case TherapyConditionDtoTherapyCondition.NO_NEGATIVE_FEELING:
      return 'Keine negative Befindung';
    case TherapyConditionDtoTherapyCondition.BAD_NORMAL_WORK:
      return 'Schlecht, normal zur Arbeit';
    case TherapyConditionDtoTherapyCondition.BAD_PART_TIME_WORK:
      return 'Sehr schlecht, Arbeit nur Teilzeit';
    case TherapyConditionDtoTherapyCondition.BAD_NO_WORK:
      return 'Sehr schlecht, arbeitsunfähig';
  }
}

export function getLatestTherapyCondition(conditions?: TherapyConditionDto[] | null) {
  if (!conditions?.length) return undefined;

  return conditions.reduce(
    (latest, current) => (differenceInMilliseconds(current.date, latest.date) > 0 ? current : latest),
    conditions[0],
  );
}
